import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';
import { SubTitleSection } from 'ui/components/public/patterns/Top/SubTitleSection';
import { useLocation } from 'react-router-dom';

const Wrapper = styled.div`
    font-weight: 700;

    @keyframes kvFadein {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes kvFadeinY {
        0% {
            opacity: 0;
            translate: -50% 25px;
        }
        100% {
            opacity: 1;
            translate: -50% 0;
        }
    }
    @keyframes kvFadeinZoom {
        0% {
            opacity: 0;
            scale: 0.9;
        }
        100% {
            opacity: 1;
            scale: 1;
        }
    }
`;

export const AboutMany: React.FC = () => {
    const ticking = useRef(false);
    const fadeItems = useRef<NodeListOf<Element> | null>(null);
    const fadeItemsLi = useRef<NodeListOf<Element> | null>(null);
    const location = useLocation();

    useEffect(() => {
        // topページにのみ適用するcssを追加
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/top.css';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    useEffect(() => {
        // フェードイン処理
        fadeItems.current = document.querySelectorAll('.fadein');
        fadeItemsLi.current = document.querySelectorAll('.fadeinLi');

        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const fadePoint = 350;

            fadeItems.current?.forEach((e) => {
                const itemTop = e.getBoundingClientRect().top + scrollTop;

                if (
                    scrollTop + windowHeight - fadePoint > itemTop ||
                    scrollTop + windowHeight >= documentHeight - 100
                ) {
                    e.classList.add('scroll_on');
                }
            });

            fadeItemsLi.current?.forEach((e) => {
                const itemTop = e.getBoundingClientRect().top + scrollTop;
                const childfadeItems = Array.from(e.children);
                if (scrollTop + fadePoint > itemTop) {
                    childfadeItems.forEach((elm, i) => {
                        setTimeout(() => {
                            elm.classList.add('scroll_on');
                        }, 300 * i);
                    });
                }
            });

            ticking.current = false;
        };

        function onScroll() {
            if (!ticking.current) {
                requestAnimationFrame(handleScroll);
                ticking.current = true;
            }
        }

        window.addEventListener('scroll', onScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    useEffect(() => {
        if (location.hash) {
            const targetId = location.hash.replace('#', '');
            const el = document.getElementById(targetId);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location.hash]);

    return (
        <Wrapper>
            <TopHeader />
            <main id="home">
                <SubTitleSection />
            </main>
            <TopFooter />
        </Wrapper>
    );
};
